module.exports = __webpack_public_path__ + "static/img/1763_phase_function_Paper_PointsHejduk_Prediction.97c1b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1763_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kukY
// module chunks = 0